// extracted by mini-css-extract-plugin
export default {"container":"Cv06","blockTitle":"X298"};